import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

// ----------------------------------------------------------------------

export function scrollToTop() {
  window.scrollTo(0, 0);
}

export default function ScrollToTop() {
  const { pathname, search } = useLocation();
  const tab = new URLSearchParams(search).get('tab');

  useEffect(() => {
    scrollToTop();
  }, [pathname, tab]);

  return null;
}
